<template>
    <div class="de-text-bar">
        <Bar
            :value="100"
            :mode="'x'"
            :color="color"
            :backgroundColor="'rgba(3,140,251,0.20)'"
        ></Bar>
    </div>
</template>

<script>
import Bar from '@/runtime-components/components/rank/rank/yBar';

export default {
    name: 'de-text-bar',
    components: {
        Bar
    },
    props: {
        color: {
            type: String
        }
    }
}
</script>

<style lang="less">

</style>